import React from "react";

export interface ActiveFilterItem {
  id: string;
  label: string;
  remove: () => void;
}

interface ActiveFiltersBarProps {
  activeFilters: ActiveFilterItem[];
  onClearAll: () => void;
  crossIconSvg: string;
}

const withoutParentheticalText = (text: string) =>
  text.replace(/\s*\([^)]*\)/g, "").trim();

export const ActiveFiltersBar: React.FC<ActiveFiltersBarProps> = ({ activeFilters, onClearAll, crossIconSvg }) => (
  <section aria-label="Aktiva filter" className="project-search-react__active-filters-section">
    <div className="active-filters active-filters--job-search active-filters--visible-mobile">
      <div className="active-filters__heading">Aktiva filter:</div>
      <ul>
          {activeFilters.map(filter => {
            let label = withoutParentheticalText(filter.label);

            return <li key={filter.id}>
                    <div className={`active-filters__wrapper`}>
                      <span className="active-filters__title">
                          {label}
                      </span>
                      <button
                        type="button"
                        className="active-filters__icon"
                        onClick={filter.remove}
                        aria-label={`Ta bort valt filter: ${label}`}
                      >
                          <span className="sr-only">
                            Ta bort valt filter: {label}
                          </span>
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 17 16"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                          >
                            <use href={`${crossIconSvg}`} />
                          </svg>
                      </button>
                    </div>
                  </li>
          })}
        <li className="clear-filters active-filters__clear-filters">
          <button
            type="button"
            className="clear-filters__linkbutton clear-filters__clear active-filters__clear-filters-btn"
            aria-label={`Rensa alla filter (${activeFilters.length})`}
            onClick={onClearAll}
          >
            {`Rensa alla filter (${activeFilters.length})`}
          </button>
        </li>
      </ul>
    </div>
  </section>
);
